const accountsTypes = {

  index: {
    request: "ACCOUNTS_INDEX_REQUEST",
    success: "ACCOUNTS_INDEX_SUCCESS",
    failure: "ACCOUNTS_INDEX_FAILURE"
  },

  autocomplete: {
    request: "ACCOUNTS_AUTOCOMPLETE_REQUEST",
    success: "ACCOUNTS_AUTOCOMPLETE_SUCCESS",
    failure: "ACCOUNTS_AUTOCOMPLETE_FAILURE",
    reset: "ACCOUNTS_AUTOCOMPLETE_RESET",
    filter_success: "ACCOUNTS_AUTOCOMPLETE_FILTER_SUCCESS"
  },

  create: {
    init: "CREATE_ACCOUNT_INIT",
    request: "CREATE_ACCOUNT_REQUEST",
    success: "CREATE_ACCOUNT_SUCCESS",
    failure: "CREATE_ACCOUNT_FAILURE"
  },

  update: {
    request: "UPDATE_ACCOUNT_REQUEST",
    success: "UPDATE_ACCOUNT_SUCCESS",
    failure: "UPDATE_ACCOUNT_FAILURE"
  },

  get: {
    request: "GET_ACCOUNT_REQUEST",
    success: "GET_ACCOUNT_SUCCESS",
    failure: "GET_ACCOUNT_FAILURE"
  },

  destroy: {
    request: "DESTROY_ACCOUNT_REQUEST",
    success: "DESTROY_ACCOUNT_SUCCESS",
    failure: "DESTROY_ACCOUNT_FAILURE"
  },

  lock: {
    request: "LOCK_ACCOUNT_REQUEST",
    success: "LOCK_ACCOUNT_SUCCESS",
    failure: "LOCK_ACCOUNT_FAILURE"
  },

  reset_errors: "RESET_ACCOUNT_ERRORS"

}

export default accountsTypes



// WEBPACK FOOTER //
// ./src/js/constants/accountsTypes.js